"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CHANGE_CHANNEL = "\n  mutation SaveRecentChannel($channelId: ID!) {\n      saveRecentChannel(channelId: $channelId)\n  }\n";
exports.default = CHANGE_CHANNEL;
//# sourceMappingURL=changeChannel.js.map